<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div>
    <el-form label-width="80px" class="">
      <el-row>
        <el-col :span="6">
          <el-form-item label="编码" prop="">
            <el-input v-model="query.lebccode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="名称" prop="">
            <el-input v-model="query.lebcname"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="分类" prop="">
            <el-select v-model="query.lebcletid" :clearable="true" >
              <el-option v-for="(item, index) in letList" :label="item.letname" :value="item.letid" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button icon="search" @click="getPageList">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange"></vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'lebcIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'lebccode', fieldtype: 'C', title: '编码',calculExpr:'', addNewRowFlg: false},
          { field: 'lebcname', fieldtype: 'C', title: '名称',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcmodel', fieldtype: 'C', title: '型号',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcsize', fieldtype: 'C', title: '规格',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcbarcode', fieldtype: 'C', title: '条形码',calculExpr:'',addNewRowFlg: false},
          { field: 'letname', fieldtype: 'C', title: '分类名',calculExpr:'',addNewRowFlg: false},
          { field: 'unitname', fieldtype: 'C', title: '计量单位',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcpprice', fieldtype: 'F', title: '采购价格',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcsprice', fieldtype: 'F', title: '销售价格',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcinvaliddesc', fieldtype: 'C',title: '作废',calculExpr:'',addNewRowFlg: false},
          { field: 'lebcremark', fieldtype: 'C',title: '备注',calculExpr:'',addNewRowFlg: false}
        ],
        letList: [],
        lebc: {},
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addLebc())
      this.$on('CHG', () => this.chgLebc())
      this.$on('DEL', () => this.delLebc())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getLetList()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' (to,from) {
        if (from.name === 'lebcForm') {
          this.getPageList()
        }
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      async init() {
        this.menuid = this.$route.query.menuid
        this.list = []
        this.letList = []
        this.lebc = {}
      },
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async getLetList () {
        this.letList = await request({
          method: 'get',
          url: '/basic/let/getLetEndList',
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
      },
      async addLebc () {
        let form = {
          lebcid: 0,
          lebcinvalid: 0
        }
        this.$router.push({name: 'lebcForm', params: {form: form, type: 1}})
      },
      async chgLebc () {
        this.$router.push({name: 'lebcForm', params: {form: this.lebc, type: 2}})
      },
      async delLebc () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/basic/lebc/delLebc',
            method: "post",
            data: this.lebc
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      handleSizeChange (val) {
        this.query.pageSize = val
        this.getPageList()
      },
      handleCurrentChange (val) {
        this.offset = val
        this.getPageList()
      },
      async cellClick (row) {
        this.lebc = row.row
      },
      async pagechange (lebcPage) {
        this.query.currPage = lebcPage.currentPage
        this.query.pageSize = lebcPage.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/basic/lebc/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
